module.exports = __webpack_public_path__ + "5fa865c70bd3ba3443e17e4ca8e35e53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/hero_bg_m@3x.jpg
// module id = 664
// module chunks = 0